import React from "react";
import {render} from "react-dom";
import {applyMiddleware, compose, createStore} from "redux";
import {Provider} from "react-redux";
import thunk from "redux-thunk";
import mwapi from "./middleware/MittwaldApi";
import reducers from "./reducers/index.configurator";
import "core-js/es5";
import "core-js/es6/array";
import "core-js/es6/object";
import "core-js/es6/string";
import "core-js/es7/object";
import "core-js/es7/array";

import createEngine from 'redux-storage-engine-localstorage'
import * as storage from 'redux-storage'
import filter from 'redux-storage-decorator-filter'
import debounce from 'redux-storage-decorator-debounce'
import ArticleConfiguratorApp from "./app/ArticleConfiguratorApp";
import {lsConfigurator} from "./config/Config";
import {_configuratorMode} from "./selectors/GetParam";

import "../public/css/Configurator.css"

// **************************************************************************************************************
try {
    // set Domain for cross-origin policy
    if(document.domain.includes('ddev.site')) {
        document.domain = "mittwald.ddev.site"
    } else {
        document.domain = "mittwald.de"
    }
} catch (e) {
}

let store

const renderApp = () => {
    render(
        <Provider store={store}>
            <ArticleConfiguratorApp/>
        </Provider>,
        document.getElementById('root')
    )
}

let engine = debounce(filter(createEngine(lsConfigurator + "_" + (_configuratorMode || 'shared')), [['form', 'projectSelection']], null), 1500)

const storageMiddleware = storage.createMiddleware(engine)
const middleware = [thunk, mwapi, storageMiddleware]
const load = storage.createLoader(engine);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(
    applyMiddleware(...middleware)
);

store = createStore(
    reducers,
    {},
    enhancer
)

load(store).then((newState) => {
    renderApp()
})



/** WEBPACK FOOTER **
 ** ./src/configurator.js
 **/